const Validator = {
  // 判断手机有效性
  // 手机号码
  // 移动：134[0-8],135,136,137,138,139,150,151,157,158,159,182,187,188
  // 联通：130,131,132,152,155,156,185,186
  // 电信：133,1349,153,180,181,189
  validPhone(phone) {
    phone = phone || '';
    // var regexTestPhone = /^1(3[0-9]|5[0-35-9]|8[0125-9])\d{8}$/;
    // // 中国移动
    // var regexTestChinaMobile = /^1(34[0-8]|(3[5-9]|5[017-9]|8[278])\d)\d{7}$/;
    // // 中国联通
    // var regexTestChinaUnicome = /^1(3[0-2]|5[256]|8[56])\d{8}$/;
    // // 中国电信
    // var regexTestChinaTelecom = /^1((33|53|8[019])[0-9]|349)\d{7}$/;
    // return regexTestPhone.test(phone) &&
    // (regexTestChinaMobile.test(phone) ||
    // regexTestChinaUnicome.test(phone) ||
    // regexTestChinaTelecom.test(phone));
    return /^1\d{10}$/.test(phone);
  },

  // 验证token是否有效
  validToken(timestamp, expires_in) {
    let result = null;
    const scale = 1000;
    if (!timestamp || !expires_in || typeof timestamp !== 'number' || typeof expires_in !== 'number') {
      result = false;
    } else {
      result = (new Date().getTime() < (timestamp + expires_in * scale));
    }
    return result;
  },
};

export default Validator;



/** WEBPACK FOOTER **
 ** ./src/modules/validator.js
 **/